/**
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { createLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import React from 'react'

import { logger } from '../../../logger'

const loadFn = /* #__LOADABLE__ */ async () =>
  await import(/* webpackChunkName: "FloorplanDetailModalContainer" */ './index')

const onLoadingError = (error: unknown) => {
  logger.error('loading error for FloorplanDetailModalLoadable', error)
}

const handleReload = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    FloorplanDetailModalLoadable.reload()
  } catch (error) {
    logger.info('Failed to reload FloorplanDetailModalLoadable', error)
  }
}

const options = {
  errorFallback: () => (
    <ErrorFallback
      message="Error loading FloorplanDetailModalLoadable"
      onClickReload={handleReload}
    />
  ),
  loadingFallback: () => <LoadingFallback name="FloorplanDetailModal" />,
  onLoadingError,
}

export const FloorplanDetailModalLoadable = createLoadableSection(loadFn, options)
